import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, AfterViewInit, inject } from '@angular/core';
import { ListaArchivosComponent } from '../../../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { LoaderComponent } from '../../../../commons/components/loader/loader.component';
import { EnumAccionDictamen, EnumEstadoDictaminacion } from '../interface/enum-estado-dictaminacion';
import { DictaminacionService } from '../dictaminacion-service';
import { DataEnrolamiento } from '../interface/response-enrolamiento-data-interface';
import { Documents } from '../../../../commons/class/archivo.inteface';
import { ElectronicDemandService } from '../../../demanda/electronicDemand.service';
import { AlertService } from '../../../../commons/components/alert/alert.service';
import { AlertComponent } from "../../../../commons/components/alert/alert.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RequestAutoenrolamientoInterface, ResponseCerrar } from '../interface/request-autoenrolamiento-interface';
import { DataAutoenrolamientoResponse } from '../interface/response-autoenrolamiento-interface';
import { RequestRechazoInterface } from '../interface/request-rechazo-interface';
import { RequestEnvioCorreoInterface } from '../interface/request-envio-correo-interface';
import { IpService } from '../../../../commons/services/ipService.service';

@Component({
  selector: 'oaj-dictaminacion-positiva-component',
  imports: [ListaArchivosComponent, LoaderComponent, AlertComponent, ReactiveFormsModule],
  templateUrl: './oaj-dictaminacion-positiva-component.html',
  styleUrl: './oaj-dictaminacion-positiva-component.css',
})
export class OajDictaminacionPositivaComponent implements OnInit, AfterViewInit {
  @Input() idAutoEnrolamiento = 0;
  @Input() idUsuario = 0;
  @Output() Regresar = new EventEmitter<any>();
  public isLoadingClass = false;
  public isLoading = false;
  public sMensajeLoad = "Cargando información, por favor espere...";
  public isFailed = false;
  public sMensajeError = "";
  enumEstadoDictaminacion = EnumEstadoDictaminacion;
  estadoDictaminacion: EnumEstadoDictaminacion = EnumEstadoDictaminacion.CargandoInformacion;
  enumAccionDictamen = EnumAccionDictamen;
  accionDictamen: EnumAccionDictamen = EnumAccionDictamen.Aceptar;
  public sHeaderModal = "Confirmación de dictamen positivo";
  public sMensajeModal = "¿Está seguro en dar de alta a la autoridad?, con la acción, se creará un usuario con su contraseña temporal y no podrá cambiar el estatus de la solicitud.";
  _DataEnrolamiento: DataEnrolamiento | undefined;
  public lstDocumentos: any[] = [];
  public isFileComplete = false;
  public sHedaer = "Emitir Dictamen.";
  public responseAutoenrolamiento: DataAutoenrolamientoResponse | undefined;
  private ip = '';

  //sMensajeCorreo = new FormControl('');
  correoForm = new FormGroup({
    sMensajeCorreo: new FormControl('', [Validators.maxLength(4999)]),
  });
  correoRechazoForm = new FormGroup({
    sMensajeCorreoRechazo: new FormControl('', [Validators.required, Validators.maxLength(4999)]),
  });

  private service: DictaminacionService = inject(DictaminacionService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private alertService: AlertService = inject(AlertService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private ipService = inject(IpService);

  ngOnInit(): void {
    this.ObtenerInformacion();
    this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
                console.log('IP obtenida:', this.ip);
            }
        );
  }


  ngAfterViewInit() {
    this.cdr.detectChanges(); // lanza un chequeo nuevo (cautela con uso excesivo)
  }

  /**
    * Función para realizar la acción de confirmación en el modal, dependiendo de la acción a realizar, ejecuta la función correspondiente para realizar la petición al servicio y cambiar el estado del componente para mostrar el siguiente paso del flujo de dictaminación
    */
  fnConfitrmarModal() {
    switch (this.accionDictamen) {
      case EnumAccionDictamen.Aceptar:
        if (this.estadoDictaminacion === EnumEstadoDictaminacion.ConfirmaCorreo) {
          this.sMensajeLoad = "Enviando notificación a la autoridad, por favor espere...";
          this.SendCorreoOK();
        }
        else {
          if (this.estadoDictaminacion === EnumEstadoDictaminacion.DatosGenerales) {
            this.sMensajeLoad = "Enviando notificación a la autoridad, por favor espere...";
            this.dictaminacionPositiva();
          }

        }

        break;
      case EnumAccionDictamen.Rechazar:
        if (this.estadoDictaminacion === EnumEstadoDictaminacion.CorreoRechazoDictamen) {
          this.sMensajeLoad = "Enviando notificación de rechazo a la autoridad, por favor espere...";
          this.SendCorreoRechazo();
        }
        else {
          this.sMensajeLoad = "Enviando notificación de rechazo a la autoridad, por favor espere...";
          this.estadoDictaminacion = EnumEstadoDictaminacion.CorreoRechazoDictamen;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }
        break;
      case EnumAccionDictamen.RechazoExito:
        this.sMensajeLoad = "Enviando notificación de rechazo a la autoridad, por favor espere...";
        this.estadoDictaminacion = EnumEstadoDictaminacion.DictamenNoNotificado;
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        break;
      case EnumAccionDictamen.AltaExito:
        this.sMensajeLoad = "Enviando notificación de alta a la autoridad, por favor espere...";
        this.estadoDictaminacion = EnumEstadoDictaminacion.DictamenNotificado;
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        break;
    }


  }

  /**
   * Función para configurar el mensaje del modal dependiendo de la acción a realizar, asigna el título y mensaje del modal dependiendo de la acción que se va a realizar para mostrar la información correcta al usuario en el modal de confirmación
   * @param opcion 
   */
  fnSetMensajeDialog(opcion: number) {
    switch (opcion) {
      case EnumAccionDictamen.Aceptar:
        this.accionDictamen = EnumAccionDictamen.Aceptar;
        this.sHeaderModal = "Confirmación de dictamen positivo";
        this.sMensajeModal = "¿Está seguro en dar de alta a la autoridad?, con la acción, se creará un usuario con su contraseña temporal y no podrá cambiar el estatus de la solicitud.";
        break;
      case EnumAccionDictamen.Rechazar:
        this.accionDictamen = EnumAccionDictamen.Rechazar;
        this.sHeaderModal = "Confirmación de rechazo de dictamen";
        this.sMensajeModal = "¿Está seguro de enviar la negativa?, una vez enviado el correo de rechazo no se podrá modificar.";
        break;
      case EnumAccionDictamen.NotificarAlta:
        this.sHeaderModal = "Envio de Notificación de Alta";
        this.sMensajeModal = "¿Está seguro de enviar la notificación de alta?";
        break;
      case EnumAccionDictamen.NotificarRechazo:
        this.sHeaderModal = "Confirmación de rechazo de dictamen";
        this.sMensajeModal = "¿Está seguro de enviar la negativa?, con la acción, se enviará correo a la cuenta de la autoridad y no podrá cambiar el estatus de la solicitud.";
        break;
    }
  }

  /**
   * Función para obtener la información general de la solicitud, hace la petición al servicio y dependiendo de la respuesta, asigna la información a mostrar en el componente y muestra mensajes en caso de error
   */
  ObtenerInformacion(): void {
    this.isLoading = true;
    this.isLoadingClass = true;
    this.service.getDataAutoEnrolamiento(this.idAutoEnrolamiento).subscribe({
      next: (response: any) => {
        if (response.succcess && response.data) {
          this.isLoading = false;
          this.isLoadingClass = false;
          this._DataEnrolamiento = response.data;
          this.estadoDictaminacion = EnumEstadoDictaminacion.DatosGenerales;
          this.GetDocumentosPantalla(this._DataEnrolamiento?.sGUID).then((resolve) => {
            this.lstDocumentos = resolve;
            this.isFileComplete = true;
            this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          });
        }
        else {
          this.sMensajeError = response.message || "Ocurrió un error al cargar la información, por favor intente más tarde.";
          this.isLoading = false;
          this.isFailed = true;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          setTimeout(() => {
            this.isFailed = false;
            this.isLoadingClass = false;
            this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          }, 5000);
        }
      },
      error: (error) => {
        console.error(JSON.stringify(error));
        this.isLoading = false;
        this.sMensajeError = "Ocurrió un error al cargar la información, por favor intente más tarde.";
        this.isFailed = true;
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        setTimeout(() => {
          this.isFailed = false;
          this.isLoadingClass = false;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }, 5000); // Ocultar mensaje después de 5 segundos
      }
    });
  }

  /**
   * Función para obtener los documentos relacionados a la solicitud, hace la petición al servicio y dependiendo de la respuesta, asigna la lista de documentos para mostrarlos en el componente y muestra mensajes en caso de error
   * @param uuid 
   * @returns 
   */
  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

    return new Promise((resolve) => {
      //this.isLoadingFile = true;
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            //this.isLoadingFile = false;
            resolve(response);
          }
          else {
            //this.isLoadingFile = false;
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          //this.isLoadingFile = false;
          resolve([]);
        });

    });
  }

  /**
   * Función para cancelar el flujo de rechazo y regresar al estado de datos generales, cambia el estado del componente para mostrar la información general de la solicitud y ocultar el formulario de motivo de rechazo
   */
  fnCancelarRechazo() {
    this.sMensajeLoad = "Cargando información, por favor espere...";
    this.estadoDictaminacion = EnumEstadoDictaminacion.DatosGenerales;
    this.cdr.detectChanges(); // <- fuerza actualización con OnPush
  }

  /**
   * Función para enviar el correo de notificación de dictamen positivo, hace la petición al servicio y dependiendo de la respuesta, muestra mensajes y cambia el estado del componente
   */
  SendCorreoOK() {

    if (this.correoForm.invalid) {
      // Opcional: Marcar todos los campos como tocados para mostrar errores
      this.correoForm.markAllAsTouched();
      return; // No continuar
    }
    this.isLoading = true;
    this.isLoadingClass = true;
    const request: RequestEnvioCorreoInterface = {
      Id: this.idAutoEnrolamiento,
      UsuarioId: this.idUsuario,
      Complemento: this.correoForm.value.sMensajeCorreo || "",
      sIP: this.ip
    }
    this.service.postDictaminacionConfirma(request).subscribe({
      next: (response: any) => {

        if (response.succcess && response.data) {
          this.isLoading = false;
          this.isLoadingClass = false;
          this.responseAutoenrolamiento = response.data;
          this.alertService.success("Dictaminación confirmada correctamente", { autoClose: true, keepAfterRouteChange: false });
          this.estadoDictaminacion = EnumEstadoDictaminacion.DictamenNotificado;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoading = false;
          this.sMensajeError = "Ocurrió un error al enviar el correo, por favor intente más tarde.";
          this.isFailed = true;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          setTimeout(() => {
            this.isFailed = false;
            this.isLoadingClass = false;
            this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          }, 5000); // Ocultar mensaje después de 5 segundos
        }
      },
      error: (error) => {
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        this.isLoading = false;
        this.sMensajeError = "Ocurrió un error al enviar el correo, por favor intente más tarde.";
        this.isFailed = true;
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        setTimeout(() => {
          this.isFailed = false;
          this.isLoadingClass = false;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }, 5000); // Ocultar mensaje después de 5 segundos
      }
    });

  }

  /**
   * Función para enviar el correo de rechazo, hace la petición al servicio y dependiendo de la respuesta, muestra mensajes y cambia el estado del componente
   */
  SendCorreoRechazo() {
    if (this.correoRechazoForm.invalid) {
      // Opcional: Marcar todos los campos como tocados para mostrar errores
      this.correoRechazoForm.markAllAsTouched();
      return; // No continuar
    }
    this.isLoading = true;
    this.isLoadingClass = true;
    const request: RequestRechazoInterface = {
      Id: this.idAutoEnrolamiento,
      UsuarioId: this.idUsuario,
      Motivo: this.correoRechazoForm.value.sMensajeCorreoRechazo || "",
      sIP: this.ip
    }
    this.service.postDictaminacionRechazo(request).subscribe({
      next: (response: any) => {
        if (response.succcess && response.data) {
          this.responseAutoenrolamiento = response.data;
          this.alertService.success("Dictaminación rechazada correctamente", { autoClose: true, keepAfterRouteChange: false });
          this.estadoDictaminacion = EnumEstadoDictaminacion.DictamenNoNotificado;
          this.isLoadingClass = false;
          this.isLoading = false;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoading = false;
          this.sMensajeError = "Ocurrió un error al rechazar la dictaminación, por favor intente más tarde.";
          this.isFailed = true;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          setTimeout(() => {
            this.isFailed = false;
            this.isLoadingClass = false;
            this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          }, 5000); // Ocultar mensaje después de 5 segundos
        }
      },
      error: (error) => {
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        this.isLoading = false;
        this.sMensajeError = "Ocurrió un error al rechazar la dictaminación, por favor intente más tarde.";
        this.isFailed = true;
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        setTimeout(() => {
          this.isFailed = false;
          this.isLoadingClass = false;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }, 5000); // Ocultar mensaje después de 5 segundos
      }
    });
  }

  /**
   * Función para realizar la dictaminación positiva, hace la petición al servicio y dependiendo de la respuesta, muestra mensajes y cambia el estado del componente para mostrar el siguiente paso que es el envío de correo de notificación
   */
  dictaminacionPositiva() {
    this.isLoading = true;
    this.isLoadingClass = true;
    const request: RequestAutoenrolamientoInterface = {
      Id: this.idAutoEnrolamiento,
      UsuarioId: this.idUsuario,
      sIP: this.ip
    }
    this.service.postDictaminacionPositiva(request).subscribe({
      next: (response: any) => {
        if (response.succcess && response.data) {
          this.isLoading = false;
          this.isLoadingClass = false;
          this.responseAutoenrolamiento = response.data;
          this.alertService.success("Dictaminación positiva registrada correctamente", { autoClose: true, keepAfterRouteChange: false });
          this.estadoDictaminacion = EnumEstadoDictaminacion.ConfirmaCorreo;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoading = false;
          this.sMensajeError = "Ocurrió un error al procesar la solicitud, por favor intente más tarde.";
          this.isFailed = true;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          setTimeout(() => {
            this.isFailed = false;
            this.isLoadingClass = false;
            this.cdr.detectChanges(); // <- fuerza actualización con OnPush
          }, 5000); // Ocultar mensaje después de 5 segundos
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.sMensajeError = "Ocurrió un error al procesar la solicitud, por favor intente más tarde.";
        this.isFailed = true;
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        setTimeout(() => {
          this.isFailed = false;
          this.isLoadingClass = false;
          this.cdr.detectChanges(); // <- fuerza actualización con OnPush
        }, 5000); // Ocultar mensaje después de 5 segundos
      }
    });
  }

  /**
   * Función para regresar al componente principal de dictaminación, emite un evento con el id del mensaje a mostrar y el mensaje a mostrar en el componente padre
   * @param idMensaje 
   * @param sMensaje 
   */
  regresarClick(idMensaje: number, sMensaje: string) {
    const responseCerrar: ResponseCerrar = {
      id: idMensaje,
      mensaje: sMensaje
    }
    this.Regresar.emit(responseCerrar);
  }

  /**
   * Función para iniciar el flujo de rechazo del dictamen, cambia el estado para mostrar el formulario de motivo de rechazo y el envío del correo de rechazo
   */
  fnRechazarDictamenPrev() {
    this.accionDictamen = EnumAccionDictamen.Rechazar;
    this.sMensajeLoad = "Enviando notificación de rechazo a la autoridad, por favor espere...";
    this.estadoDictaminacion = EnumEstadoDictaminacion.CorreoRechazoDictamen;
    this.cdr.detectChanges(); // <- fuerza actualización con OnPush
  }

}
